import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import styles from "./ChangeEmailComponent.module.css";
import {changeEmail} from "../../api/AuthApi";

const ChangeEmailComponent: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [newEmail, setNewEmail] = useState("");
    const [confirmEmail, setConfirmEmail] = useState("");

    const [message, setMessage] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    const [newEmailError, setNewEmailError] = useState(false);
    const [confirmEmailError, setConfirmEmailError] = useState(false);

    const isEmailValid = (email: string) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setMessage(null);
        setNewEmailError(false);
        setConfirmEmailError(false);

        if (!isEmailValid(newEmail)) {
            setNewEmailError(true);
            setMessage("Enter a valid email address.");
            return;
        }

        if (newEmail !== confirmEmail) {
            setNewEmailError(true);
            setConfirmEmailError(true);
            setMessage("Emails do not match.");
            return;
        }

        try {
            await changeEmail({newEmail});
            setSuccess(true);
            setMessage("Email updated successfully.");
        } catch (err: any) {
            if (err.message) {
                setMessage(err.message);
            }
        }
    };

    const handleGoBack = () => navigate('/');

    return (
        <nav className={styles.headerNav}>
            {location.pathname !== '/' && location.pathname !== '/login' &&
                <button className="btn btn-primary-light" onClick={handleGoBack}>Back</button>}
            <div className={styles.container}>
                <h1 className={styles.title}>Change Email</h1>

                {!success ? (
                    <>
                        <input
                            className={`${styles.input} ${newEmailError ? styles.inputError : ""}`}
                            type="email"
                            placeholder="New Email"
                            value={newEmail}
                            onChange={(e) => setNewEmail(e.target.value)}
                        />
                        {newEmailError && <p className={styles.error}>Enter a valid or unused email.</p>}

                        <input
                            className={`${styles.input} ${confirmEmailError ? styles.inputError : ""}`}
                            type="email"
                            placeholder="Confirm New Email"
                            value={confirmEmail}
                            onChange={(e) => setConfirmEmail(e.target.value)}
                        />
                        {confirmEmailError && <p className={styles.error}>Emails must match.</p>}

                        <button className={styles.button} onClick={handleSubmit}>
                            Update Email
                        </button>

                        {message && !newEmailError && !confirmEmailError && (
                            <p className={styles.error}>{message}</p>
                        )}
                    </>
                ) : (
                    <p className={styles.success}>{message}</p>
                )}
            </div>
        </nav>
    );
};

export default ChangeEmailComponent;